/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPersonHeart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0z" />
        <path d="M15.836 3h-.011l-.265.006h-.011A6.23 6.23 0 0 0 12 4.317c-2.42-1.896-5.955-1.743-8.195.459a5.99 5.99 0 0 0 0 8.57L12 21.402l8.194-8.056A6.009 6.009 0 0 0 22 9.06c0-1.61-.651-3.151-1.806-4.286A6.217 6.217 0 0 0 15.836 3zm-.207 2.005L15.847 5a4.217 4.217 0 0 1 2.945 1.2A4.01 4.01 0 0 1 20 9.06a4.008 4.008 0 0 1-1.207 2.859l-4.199 4.128c-.101-.1-.21-.195-.326-.284-.664-.508-1.5-.763-2.463-.763-1.057 0-1.93.31-2.587.863l-4.01-3.944a3.99 3.99 0 0 1 0-5.718c1.398-1.374 3.553-1.569 5.165-.583.266.162.517.357.747.583l.88.864.88-.864a4.199 4.199 0 0 1 2.75-1.196zM10.66 17.28c.272-.173.64-.28 1.145-.28.603 0 .99.155 1.248.351.04.03.078.063.115.099L12 18.598zM12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgPersonHeart as PersonHeart };
